module.exports = __webpack_public_path__ + "static/media/guardian-team-bottom.9c4d0a0a.webp";